import classnames from "classnames";
import React from "react";

import "./selection-box.css";

export const SelectionBox = ({
	canSelect = false,
	isSelected = false,
	children,
	className,
}: React.PropsWithChildren<{
	/** Show selection circle */
	canSelect?: boolean;
	/** Show as selected */
	isSelected?: boolean;
	className?: string;
}>) => {
	const classNames = classnames(className, "selection-box", {
		"selection-box--can-select": canSelect,
		"selection-box--is-selected": isSelected,
	});

	return (
		<div className={classNames}>
			{children}
			<div className="selection-box__checkmark" />
		</div>
	);
};
SelectionBox.displayName = "SelectionBox";
